import React from 'react'
import { useNavigate } from 'react-router-dom'
import errorImage from '@app/assets/images/404.svg'

import { Header } from '@app/components'
import { ContentLayout } from '@app/layouts'

import { BUTTON_TYPE, SIZE } from '@app/constants'
import { BASE_PAGE } from '@app/constants/page'

import { LntButton, LntImage } from '@app/components/base'

import styles from './styles.module.scss'

export const ErrorPage: React.FC = () => {
  const navigate = useNavigate()

  return (
    <>
      <Header />

      <ContentLayout>
        <div className={ styles.errorPage }>
          <LntImage
            src={ errorImage }
            preview={ false }
            width={ 468 }
            height={ 192 }
            alt='Страница не найдена'
            title='Страница не найдена'
          />
          <span className={ styles.errorPage__title }>Страница не найдена</span>
          <span className={ styles.errorPage__description }>Возможно, она никогда не существовала или была удалена.</span>
          <LntButton
            type={ BUTTON_TYPE.primary }
            size={ SIZE.middle }
            onClick={ () => navigate(BASE_PAGE.root) }
          >
            Перейти на главную
          </LntButton>
        </div>
      </ContentLayout>
    </>
  )
}
